import { Link } from "react-router-dom";


const linkStyle = { color: "#ddd", fontWeight: "bold", textDecoration: "none" }

function LinkComponent({ href, children }) {
    return <Link to={href} style={linkStyle}>{children}</Link>;
}

export default function HomeTab() {
    return <div style={{ marginTop: "2rem", textAlign: "start" }}>
        Hi! Sorry for the announcement, but if anyone&apos;s still using the planners, I&apos;m going to stop actively updating them. Unfortunately, I&apos;m no longer actively keeping up with the game, so it doesn&apos;t make much sense for me to continue updating them. The tools will remain available, and I can still update some of the data by request, but otherwise they&apos;ll be inactive moving forward. Thanks to everyone who used them!
        <br /> <br />

        Select a tool below or from the sidebar to get started.
        <br /> <br />
        <LinkComponent href={"/dijiang-planner"}>Dijiang Planner</LinkComponent> - Plan out and optimize operator assignments in Dijiang rooms.
        <br /> <br />
        <LinkComponent href={"/pull-calculator"}>Pull Calculator</LinkComponent> - Compute rates for banner pulls.
        <br /> <br />
        <LinkComponent href={"/operator-interactions-map"}>Operator Interactions Map</LinkComponent> - View combos or interactions between operators.
        <br /> <br />
        <LinkComponent href={"/essence-farming-solver"}>Essence Farming Solver</LinkComponent> - Find the best farming spots for essences.
        <br /> <br />
        <LinkComponent href={"/essence-checker"}>Essence Checker</LinkComponent> - Check if your essences match any weapons you have or may want to pull for.
        <br /> <br />
        <LinkComponent href={"/factory-calculator"}>Factory Calculator</LinkComponent> - Compute the best products for your factory or just see the facilities needed to produce what you want.
    </div>
}